// Local translations
export const T = {
  en_GB: {
    yes: "Yes",
    no: "No",
    incompleteMessage: "Please answer every preference.",
    noPreferences: "No client preferences are defined for this flow's portfolio collection.",
  },
  nb_NO: {
    yes: "Ja",
    no: "Nei",
    incompleteMessage: "Vennligst besvar alle preferansene.",
    noPreferences: "Ingen kundepreferanser er definert for denne flytens porteføljesamling.",
  },
} as const;
